
export default {
    name: 'commonMixin',
    data() {
        return {
            currentPageTitle: null, // 页面标题
            isexportIng: true,//导出状态
            exportsModalShow: false,//导出超过1万弹窗
            exportNumLimit: 10000,//所有导出条数限制
            symbolList: [],//币种列表
            symbol: null,//币种
            searchData: {
                symbol: null
            },
            form: {
                symbol: null
            },
            tableHeight: '594px',//表格默认高度
            // 合约经纪人
            headerUpdateTime: null,//头部数据更新时间
            tipWidth: '200px',//tip提示宽度
        }
    },
    computed: {
        exportButtonText() {
            if (!this.isexportIng) {
                return this.$t("common.exportIng"); // '正在导出'
            }
            return this.$t("common.export");
        },
        // 角色类型
        roleType() {
            if (this.$store.state.baseData.user) {
               
                return this.$store.state.baseData.user.roleType
                // 1超级管理员和平台管理员 0商户管理员  3 比例经纪人 4 极差经纪人
            }
            // return 0
        },
        // 商户管理员禁用,平台不禁用
        disabledBroker() {
            if (this.roleType == 0) {
                return true
            } else {
                return false
            }
        },
        // 返佣级别下拉和列表返佣字段不显示
        disabledReturnLevel() {
            if (this.roleType == 0 || this.roleType == 1) {
                // 平台商户不显示
                return true
            } else {
                return false
            }
        },
        lan() {
            return this.$store.state.baseData.language;
        },
    },
    methods: {
        // 获取菜单
        getMenus() {
            // this.$http({
            //     url: "menus",
            // }).then((data) => {
            //     if (data.code.toString() === "0") {
            //         // 获取页面标题
            //         this.$nextTick(() => {
            //             setTimeout(() => {
            //                 this.currentPageTitle = JSON.parse(sessionStorage.getItem("currentPageTitle")).atDes
            //             }, 1200)
            //         });
            //     }
            // });
            // 获取页面标题
            this.$nextTick(() => {
                setTimeout(() => {
                    if (JSON.parse(sessionStorage.getItem("currentPageTitle"))) {
                        this.currentPageTitle = JSON.parse(sessionStorage.getItem("currentPageTitle")).atDes
                    }
                }, 2000)
            });
        },
    },
    created() {
        this.currentPageTitle = ''
        this.getMenus()

    },
    mounted() {
        if (this.$refs.headerH) {
            const headerH = this.$refs.headerH.offsetHeight
            this.tableHeight = document.documentElement.clientHeight - 80 - headerH - 60 - 37 - 55 + 'px'
            // 80头部 60表格上导出  37底部分页  60底部间距
            window.onresize = () => {
                return (() => {
                    this.tableHeight = document.documentElement.clientHeight - 80 - headerH - 60 - 37 - 55 + 'px'
                })()
            }
        }

    },
}